(function($) {
    var EngineUtil = {
        GUIDE_MSG_SELECTOR: '#engineMessage',
        NEW_SEARCH_MSG_SELECTOR: '.searchNewDates',

         //Return if this element active
        isActiveElement : function(element) {
            return $(element).closest(".radiogroup").hasClass("disabledDestination") == false;
        },

        getCurrDateEventsWrapper : function(OMCModule) {
            OMCModule = OMCModule || whereToGo;
            return $("div[pickdatemodule='israDeskDateOptions" + OMCModule + "']");
        },

        getActiveDateEventInput : function(OMCModule) {
            return EngineUtil.getCurrDateEventsWrapper(OMCModule).find(".pickDateOptionInput:checked");
        },

        getActiveDateEventOpt : function(OMCModule) {
            return EngineUtil.getActiveDateEventInput(OMCModule).closest(".pickDateOption");
        },

        getActiveDateEventText : function(OMCModule) {
            return EngineUtil.getActiveDateEventInput(OMCModule).closest(".custom-radio").find('.innerText').text();
        },

        getActiveDateEventCode : function(OMCModule) {
             return EngineUtil.getActiveDateEventInput(OMCModule).attr("data-code");
        },

        /**
         * Update guide message in engine
         *
         * @param key
         * @param message
         *
         * @returns {*}
         */
        updateGuideMessage: function (key, message) {
            var el = $(EngineUtil.GUIDE_MSG_SELECTOR);

            if (el.length > 0) {
                if (key === false && typeof message === 'string')
                    return el.text(message).attr('data-key', 'none');

                if($.TextBundleUtil.hasText(key))
                    return el.text($.TextBundleUtil.getText(key)).attr('data-key', key);
            }

            return false;
        },

        /**
         * Set guide message in engine
         * Either Hide or Show according to the active Radio button of the dates
         */
        setGuideMessage : function() {
            var el = $(EngineUtil.GUIDE_MSG_SELECTOR),
                OMCModule = $.ModuleUtil.calculateModule();

            if(el.length < 1)
                return;

            if($.LocationUtil.isGDSLocation() || $.SyncEngineUtil.isSpecificDatesRequired()) {
                if (!$.DatesUtil.isStartDateSelected()) {
                    el.removeClass("hide");
                    EngineUtil.updateGuideMessage('departDate');
                } else if (
                    !$.SyncEngineUtil.isOneWay() &&
                    !$.DatesUtil.isEndDateSelected()
                ) {
                    el.removeClass("hide");
                    EngineUtil.updateGuideMessage('returnDate');
                } else {
                    el.addClass("hide");
                }
                return;
            }

            switch (EngineUtil.getActiveDateEventCode(OMCModule)) {
                case 'calendarDate':
                    el.removeClass("hide");
                    EngineUtil.updateGuideMessage('departDate');
                    break;

                case 'unknown':
                    el.removeClass("hide");
                    EngineUtil.updateGuideMessage(false, '');
                    break;

                default:
                    el.addClass("hide");
            }
        },

        isFreeTextSearch : function (){
            return $('.search-types li.active').data("search-type") == 'regular-search';
        }
    };

    window.EngineUtil = EngineUtil;

})(jQuery);

